import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import CatalogPage from "@/pages/CatalogPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import CheckoutPage from "@/pages/CheckoutPage";
import PaymentResultPage from "@/pages/PaymentResultPage";
import PolicyPage from "@/pages/PolicyPage";
import { Toaster } from "sonner";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-cream">
        <div className="animate-spin h-8 w-8 border-4 border-coral border-t-transparent rounded-full" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CatalogPage />} />
          <Route path="/checkout/:packId" element={<CheckoutPage />} />
          <Route path="/order/:orderId" element={<PaymentResultPage />} />
          <Route path="/policies/:slug" element={<PolicyPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              fontFamily: "'Nunito', sans-serif",
              borderRadius: "16px",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
